var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "setCustomPrintImportTemplate common-dialog",
          attrs: {
            id: "batchBalanceTransfer",
            title: "面单批量转移",
            visible: _vm.isShow,
            center: "",
            "close-on-click-modal": false,
            width: "1200px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            { staticClass: "batch-transfer-container" },
            [
              _c(
                "div",
                { staticClass: "add-transfer-section" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-plus",
                        disabled: _vm.transferItems.length >= 10,
                      },
                      on: { click: _vm.addTransferItem },
                    },
                    [_vm._v("添加面单转移")]
                  ),
                  _c("span", { staticClass: "tip-text" }, [
                    _vm._v(
                      "已添加 " + _vm._s(_vm.transferItems.length) + " 个转移项"
                    ),
                  ]),
                  _vm.transferItems.length >= 10
                    ? _c(
                        "span",
                        {
                          staticClass: "tip-text",
                          staticStyle: { color: "#F56C6C" },
                        },
                        [_vm._v(" 已达到最大转移项数量（10个） ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._l(_vm.transferItems, function (item, index) {
                return _c("div", { key: index, staticClass: "transfer-item" }, [
                  _c(
                    "div",
                    { staticClass: "item-header" },
                    [
                      _c("span", { staticClass: "item-title" }, [
                        _vm._v("转移项【" + _vm._s(index + 1) + "】"),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            icon: "el-icon-delete",
                            size: "mini",
                            disabled: _vm.transferItems.length <= 1,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeTransferItem(index)
                            },
                          },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "transfer-content" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "transferForms",
                          refInFor: true,
                          attrs: {
                            inline: true,
                            model: item.form,
                            "label-width": "90px",
                          },
                        },
                        [
                          _c("el-row", [
                            _c("div", { staticClass: "balanceTitle" }, [
                              _vm._v("面单来源"),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "y-mt-10" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "customer-code",
                                      attrs: { label: "" },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "select-style",
                                          attrs: {
                                            placeholder: "请选择客户编码",
                                          },
                                          on: {
                                            change: (val) => {
                                              _vm.changeSourceKcode(val, index)
                                            },
                                          },
                                          model: {
                                            value:
                                              item.form.balanceplatform
                                                .customerCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.form.balanceplatform,
                                                "customerCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.form.balanceplatform.customerCode",
                                          },
                                        },
                                        _vm._l(
                                          _vm.tableData,
                                          function (obj, idx) {
                                            return _c("el-option", {
                                              key: idx,
                                              attrs: {
                                                label:
                                                  obj.code + "-" + obj.name,
                                                value: obj.code,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "select-label",
                                      attrs: {
                                        prop: "balanceplatform",
                                        label: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "select-style",
                                          attrs: { placeholder: "请选择平台" },
                                          on: {
                                            change: (val) => {
                                              _vm.platformChange(
                                                val,
                                                "balanceplatform",
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              item.form.balanceplatform
                                                .platform,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.form.balanceplatform,
                                                "platform",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.form.balanceplatform.platform",
                                          },
                                        },
                                        _vm._l(
                                          item.form.balanceplatform
                                            .selectPlatformList,
                                          function (obj, idx) {
                                            return _c("el-option", {
                                              key: idx + "|" + obj.code,
                                              attrs: {
                                                label: obj.name,
                                                value: obj.code,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "select-label",
                                      attrs: {
                                        prop: "balanceplatform",
                                        label: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "select-style",
                                          attrs: { placeholder: "请选择服务" },
                                          on: {
                                            change: (val) => {
                                              _vm.codServiceChange(
                                                val,
                                                "balanceplatform",
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              item.form.balanceplatform
                                                .serviceCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.form.balanceplatform,
                                                "serviceCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.form.balanceplatform.serviceCode",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { label: "普通", value: "" },
                                          }),
                                          item.form.balanceplatform.platform ==
                                            "YTO" &&
                                          item.form.balanceplatform.isCod == "Y"
                                            ? _c("el-option", {
                                                attrs: {
                                                  label: "COD",
                                                  value: "YTOCOD",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "select-label",
                                      attrs: {
                                        prop: "balanceplatform",
                                        label: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "select-style",
                                          attrs: {
                                            placeholder: "请选择客户/商家",
                                            filterable: "",
                                          },
                                          on: {
                                            change: (val) => {
                                              _vm.shopChange(
                                                val,
                                                "balanceplatform",
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              item.form.balanceplatform
                                                .sellerCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.form.balanceplatform,
                                                "sellerCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.form.balanceplatform.sellerCode",
                                          },
                                        },
                                        _vm._l(
                                          item.form.balanceplatform.sellerList,
                                          function (obj, idx) {
                                            return _c("el-option", {
                                              key: idx + "|" + obj.sellerId,
                                              attrs: {
                                                label: obj.sellerNick,
                                                value: obj.sellerId,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      item.form.balanceplatform.sellerCode
                                        ? _c(
                                            "span",
                                            { staticClass: "y-ml-10" },
                                            [
                                              _vm._v(
                                                " 余额：" +
                                                  _vm._s(
                                                    item.form.balanceplatform
                                                      .amount
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-row", [
                            _c("div", { staticClass: "balanceTitle" }, [
                              _vm._v("面单转出到"),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "y-mt-10" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "customer-code",
                                      attrs: { label: "" },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "select-style",
                                          attrs: {
                                            placeholder: "请选择客户编码",
                                          },
                                          on: {
                                            change: (val) => {
                                              _vm.changeKcode(val, index)
                                            },
                                          },
                                          model: {
                                            value:
                                              item.form.balanceOutplatform
                                                .customerCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.form.balanceOutplatform,
                                                "customerCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.form.balanceOutplatform.customerCode",
                                          },
                                        },
                                        _vm._l(item.kList, function (obj, idx) {
                                          return _c("el-option", {
                                            key: idx,
                                            attrs: {
                                              label:
                                                obj.customerCode +
                                                "-" +
                                                obj.customerName,
                                              value: obj.customerCode,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "select-label",
                                      attrs: {
                                        prop: "balanceOutplatform",
                                        label: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "select-style",
                                          attrs: { placeholder: "请选择平台" },
                                          on: {
                                            change: (val) => {
                                              _vm.platformChange(
                                                val,
                                                "balanceOutplatform",
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              item.form.balanceOutplatform
                                                .platform,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.form.balanceOutplatform,
                                                "platform",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.form.balanceOutplatform.platform",
                                          },
                                        },
                                        _vm._l(
                                          item.form.balanceOutplatform
                                            .selectPlatformList,
                                          function (obj, idx) {
                                            return _c("el-option", {
                                              key: idx,
                                              attrs: {
                                                label: obj.name,
                                                value: obj.code,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "select-label",
                                      attrs: {
                                        prop: "balanceOutplatform",
                                        label: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "select-style",
                                          attrs: { placeholder: "请选择服务" },
                                          on: {
                                            change: (val) => {
                                              _vm.codServiceChange(
                                                val,
                                                "balanceOutplatform",
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              item.form.balanceOutplatform
                                                .serviceCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.form.balanceOutplatform,
                                                "serviceCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.form.balanceOutplatform.serviceCode",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { label: "普通", value: "" },
                                          }),
                                          item.form.balanceOutplatform
                                            .platform == "YTO" &&
                                          item.form.balanceOutplatform.isCod ==
                                            "Y"
                                            ? _c("el-option", {
                                                attrs: {
                                                  label: "COD",
                                                  value: "YTOCOD",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "select-label",
                                      attrs: {
                                        prop: "balanceOutplatform",
                                        label: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "select-style",
                                          attrs: {
                                            placeholder: "请选择客户/商家",
                                            filterable: "",
                                          },
                                          on: {
                                            change: (val) => {
                                              _vm.shopChange(
                                                val,
                                                "balanceOutplatform",
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              item.form.balanceOutplatform
                                                .sellerCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.form.balanceOutplatform,
                                                "sellerCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.form.balanceOutplatform.sellerCode",
                                          },
                                        },
                                        _vm._l(
                                          item.form.balanceOutplatform
                                            .sellerList,
                                          function (obj, idx) {
                                            return _c("el-option", {
                                              key: idx + "|" + obj.sellerId,
                                              attrs: {
                                                label: obj.sellerNick,
                                                value: obj.sellerId,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      item.form.balanceOutplatform.sellerCode
                                        ? _c(
                                            "span",
                                            { staticClass: "y-ml-10" },
                                            [
                                              _vm._v(
                                                " 余额：" +
                                                  _vm._s(
                                                    item.form.balanceOutplatform
                                                      .amount
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-row", [
                            _c("div", { staticClass: "balanceTitle" }, [
                              _vm._v("转出数量"),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "padingTop10" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "", id: "number" } },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          type: "number",
                                          min: 1,
                                          max: 10000,
                                          precision: 0,
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.limitPrintNum(index)
                                          },
                                        },
                                        model: {
                                          value: item.form.quantity,
                                          callback: function ($$v) {
                                            _vm.$set(item.form, "quantity", $$v)
                                          },
                                          expression: "item.form.quantity",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("el-form-item", { attrs: { label: "" } }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "y-fc-4C84FF y-c-p",
                                        on: {
                                          click: function ($event) {
                                            return _vm.transferAllQuantityFn(
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" 全部转出 ")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              }),
              _c(
                "el-row",
                { staticClass: "padingTop18 tocenter submitbtn" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "y-fc-333 y-fw-400",
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.submitLoading },
                      on: { click: _vm.confirmBatchTransferFn },
                    },
                    [_vm._v("确定批量转移")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }